import { useFocusState, useRequestedProductType } from "../index";
import { useFormikContext } from "formik";
import { useEffect } from "react";
import { roundUpLoanAmount } from "./utilities";

export const useIncrementSnapper = (name, productTypeOverwrite = "") => {
  const [ref, isFocused] = useFocusState();
  const { setFieldValue, values } = useFormikContext();
  const requestedProductTypeFromForm = useRequestedProductType();

  const requestedProductType = !!productTypeOverwrite ? productTypeOverwrite : requestedProductTypeFromForm;
  const loanAmount = values[name];

  const onBlur = () => roundUpLoanAmount(loanAmount, name, requestedProductType, setFieldValue);

  useEffect(() => {
    if (!isFocused) {
      roundUpLoanAmount(loanAmount, name, requestedProductType, setFieldValue);
    }
  }, [isFocused, loanAmount, name, requestedProductType, setFieldValue]);

  return [ref, onBlur];
};